import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PostsList from './PostsList';
import PostCreate from './PostCreate';
import PostView from './PostView';
import PostEdit from './PostEdit';

function Posts() {
  return (
    <Routes>
      <Route index element={<PostsList />} />
      <Route path="create" element={<PostCreate />} />
      <Route path=":postId" element={<PostView />} />
      <Route path=":postId/edit" element={<PostEdit />} />
    </Routes>
  );
}

export default Posts; 